module.exports = __webpack_public_path__ + "static/media/suzette_whyte.04152bbd.pdf";